import React, { type ReactElement } from 'react'
import styled, { type CSSProperties } from 'styled-components'
import Heading from '../../general/Typography/Heading/Heading'
import Text from '../../general/Typography/Text/Text'

type Props = {
  title: string | ReactElement
  description?: string | ReactElement
  icon?: ReactElement
  /**
   * @deprecated
   * not used any more
   */
  imageSrc?: string
  children?: React.ReactNode
  /**
   * @deprecated
   * not used any more
   */
  isLoading?: boolean
  /**
   * @deprecated
   * not used any more
   */
  loader?: any
  containerStyle?: CSSProperties
  testId?: string
}

export const renderDescription = (description: Props['description']) => {
  if (!description) return null

  if (typeof description === 'string') {
    return (
      <EmptyStateDescription level={1}>{description}</EmptyStateDescription>
    )
  }

  return description
}

const renderContent = (
  description: Props['description'],
  children: Props['children']
) => {
  if (React.isValidElement(children)) {
    if (children?.props?.href) {
      return (
        <InlineWrapper>
          {renderDescription(description)}
          <LinkWrapper>{children}</LinkWrapper>
        </InlineWrapper>
      )
    }
  }
  return (
    <ContentContainer>
      {renderDescription(description)}
      {children}
    </ContentContainer>
  )
}

export function EmptyState(props: Props): ReactElement {
  const { title, description, icon, children, containerStyle, testId } = props

  return (
    <Container
      data-cy="empty-state"
      data-testid={testId || 'empty-state'}
      style={containerStyle}
    >
      <IconWrapper>{icon}</IconWrapper>
      <HeadingStyled level={2}>{title}</HeadingStyled>
      {renderContent(description, children)}
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  padding-top: 40px;
  padding-bottom: 24px;
`

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`

const IconWrapper = styled.div`
  margin-bottom: 21px;
`

const InlineWrapper = styled.div`
  font-size: 16px;
`

const LinkWrapper = styled.div`
  text-decoration: none;
  display: inline;
  padding-left: 5px;
`

const HeadingStyled = styled(Heading)`
  text-align: center;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.color.neutral.color5};
` as typeof Heading

export const EmptyStateDescription = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
  text-align: center;
` as typeof Text

export default EmptyState
